import React, { useEffect, useRef, useState } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import { useSectionViewTracking } from '../CustomHook/useSectionViewTracking';
import { LanguageLandingPage } from '../../../global-interfaces';
import s from './RunCodeYourself.scss';
import { LanguageLandingPageRunCodeYourselfType } from '../../../../../api/public/static-pages-api';
import { IApiUrls } from '../../../../../api/private/global.interface';
import { SlAnimationLoader } from '../../../../../shared/public/SlAnimationLoader/SlAnimationLoader';
import { Container } from '../../../../../symphony';

interface IAllCoursesProps {
	data: LanguageLandingPageRunCodeYourselfType;
}

export function RunCodeYourself({ data }: IAllCoursesProps): JSX.Element {
	useStyles(s);
	const cdnApiHostV2 = (Container.take('global', 'envUrl') as IApiUrls)
		.cdnApiHostV2;
	const [animationData, setAnimationData] = useState<string>(null);
	const element = useRef<HTMLElement>(null);

	useSectionViewTracking({
		ref: element,
		sectionName: LanguageLandingPage.RunCodeYourself,
		sectionTitle: data.title,
	});

	useEffect(() => {
		if (!data?.animation) return;

		fetch(`${cdnApiHostV2}${data?.animation}`)
			.then((animationRes) => {
				animationRes
					.json()
					.then(setAnimationData)
					.catch(() => {});
			})
			.catch(() => {});
	}, [data]);

	return (
		<section
			className="sl-language__run-code-yourself"
			ref={element}
			sl-test-data="cmpLanguageRunCodeYourself"
		>
			<h2 className="sl-language__run-code-yourself__title">
				{data.title}
			</h2>
			<p
				className="sl-language__run-code-yourself__description"
				dangerouslySetInnerHTML={{ __html: data.description }}
			/>
			{animationData && (
				<div className="sl-language__run-code-yourself__animation">
					<SlAnimationLoader
						show
						animationData={animationData}
						loop
					/>
				</div>
			)}
		</section>
	);
}
